import React, { useEffect, useState } from 'react';
import { InoToastProps } from './InoToast.types';
import '../../styles/InoToast.css';

const icons = {
  success: '✓',
  error: '✕',
  warning: '⚠',
  info: 'ℹ',
};

export const InoToast: React.FC<InoToastProps> = ({
  message,
  type = 'info',
  isVisible = false,
  duration = 3000,
  position = 'top-right',
  withIcon = false,
  withProgress = false,
  classNames = '',
  onClose,
}) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    let progressTimer: NodeJS.Timeout;

    if (isVisible && duration > 0) {
      // Timer for closing toast
      timer = setTimeout(() => {
        onClose?.();
      }, duration);

      // Timer for progress bar
      if (withProgress) {
        const startTime = Date.now();
        progressTimer = setInterval(() => {
          const elapsed = Date.now() - startTime;
          const remaining = Math.max(
            0,
            ((duration - elapsed) / duration) * 100
          );
          setProgress(remaining);

          if (remaining <= 0) {
            clearInterval(progressTimer);
          }
        }, 10);
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
      if (progressTimer) clearInterval(progressTimer);
    };
  }, [isVisible, duration, onClose, withProgress]);

  if (!isVisible) return null;

  return (
    <div
      className={`ino-toast ino-toast--${position} ino-toast--${type} ${classNames}`}
    >
      <div className="ino-toast__content">
        {withIcon && <span className="ino-toast__icon">{icons[type]}</span>}
        <span>{message}</span>
      </div>
      {withProgress && (
        <div className="ino-toast__progress">
          <div
            className="ino-toast__progress-bar"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
};
